module.exports = __webpack_public_path__ + "static/media/camila.b74a0255.png";